import axios from 'axios';

export const getDocumentTypes = async () => {
  return await axios.get("settings/documentTypes").then((response: any) => response.data).catch((err: any) => err);
}
